import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { DateReviverInterceptorService, ErrorInterceptorService, RedirectInterceptorService, SessionTimeoutInterceptorService, SpinnerInterceptorService } from 'cl-common-angular';

export const AppInterceptors = [
    { provide: HTTP_INTERCEPTORS, useClass: DateReviverInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RedirectInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SessionTimeoutInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptorService, multi: true }
];
